export const isMobile = () => {
    return window.innerWidth <= 768;
};

export const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}